class ImageWithPlaceholder extends HTMLElement {
  constructor() {
    super();

    this.imageEl = this.querySelector('img');

    if (!this.imageEl) {
      return;
    }

    this.loaded = this.imageEl.complete;

    if (this.loaded === false) {
      this.imageEl.addEventListener('load', this.imageLoadedHandler.bind(this));
    }

    const hoverSrc = this.getAttribute('image_on_hover');
    if (hoverSrc) {
      this._originalSrc = this.imageEl.src;
      this._originalSrcset = this.imageEl.getAttribute('srcset');
      // On product cards a full-card link (absolute inset-0 z-10) sits on top of the
      // image, so the image itself never sees the mouse. Listen on the card (.group)
      // instead, as long as it holds only this one hover image.
      const card = this.closest('.group');
      const hoverTarget =
        card && card.querySelectorAll('image-with-placeholder[image_on_hover]').length === 1 ? card : this;
      hoverTarget.addEventListener('mouseenter', () => {
        this.imageEl.src = hoverSrc;
        this.imageEl.removeAttribute('srcset');
      });
      hoverTarget.addEventListener('mouseleave', () => {
        this.imageEl.src = this._originalSrc;
        if (this._originalSrcset) this.imageEl.setAttribute('srcset', this._originalSrcset);
      });
    }
  }

  get loaded() {
    return this._loaded;
  }

  set loaded(value) {
    this._loaded = value;

    this.imageEl.classList.toggle('is-complete', value);
  }

  imageLoadedHandler(e) {
    this.loaded = this.imageEl.complete;
    this.imageEl.removeEventListener('load', this.imageLoadedHandler);
  }
}

customElements.define('image-with-placeholder', ImageWithPlaceholder);
